import { render } from "./LogoKn.vue?vue&type=template&id=ab21917c&scoped=true&ts=true"
import script from "./LogoKn.vue?vue&type=script&lang=ts"
export * from "./LogoKn.vue?vue&type=script&lang=ts"

import "./LogoKn.vue?vue&type=style&index=0&id=ab21917c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab21917c"]])

export default __exports__